import React, { createContext, useContext, useState, useEffect } from 'react';
import { getRegionConfig } from '../config/regionConfig';

const defaultRegionConfig = getRegionConfig();
const RegionContext = createContext(defaultRegionConfig);

export const useRegion = () => {
  return useContext(RegionContext);
};

export const RegionProvider = ({ children }) => {
  const [regionConfig, setRegionConfig] = useState(getRegionConfig);

  // Optionally sync with backend to support GeoIP overrides
  useEffect(() => {
    fetch('/api/website/region')
      .then((res) => res.json())
      .then((data) => {
        if (data?.region) setRegionConfig(data);
      })
      .catch(() => {
        // Silently fall back to client-side hostname detection
      });
  }, []);

  return (
    <RegionContext.Provider value={regionConfig}>
      {children}
    </RegionContext.Provider>
  );
};

export default RegionContext;
